import { useScrollReveal } from '@/hooks/useScrollReveal';
import { Award, Heart, Users } from 'lucide-react';

const COACH_IMAGES = {
  running: 'https://customer-assets.emergentagent.com/job_063f6b75-858e-4561-abbf-3c8b3baa3d11/artifacts/3tymmeqj_WhatsApp%20Image%202026-04-02%20at%2015.10.34.jpeg',
  squat: 'https://customer-assets.emergentagent.com/job_063f6b75-858e-4561-abbf-3c8b3baa3d11/artifacts/seuzapen_WhatsApp%20Image%202026-04-02%20at%2015.10.35.jpeg',
  portrait: 'https://customer-assets.emergentagent.com/job_063f6b75-858e-4561-abbf-3c8b3baa3d11/artifacts/pa1h9rcs_WhatsApp%20Image%202026-04-02%20at%2015.10.33.jpeg',
  barwork: 'https://customer-assets.emergentagent.com/job_063f6b75-858e-4561-abbf-3c8b3baa3d11/artifacts/xa15u8mu_WhatsApp%20Image%202026-04-02%20at%2015.10.34%20%281%29.jpeg',
};

export const CoachSection = ({ variant = 'home' }) => {
  const [ref, isVisible] = useScrollReveal(0.1);
  const isDark = variant === 'about';

  return (
    <section
      ref={ref}
      data-testid="coach-section"
      className={`section-padding ${isDark ? 'bg-dark' : 'bg-background'}`}
    >
      <div className="container-custom">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className={`font-semibold text-sm tracking-widest uppercase text-primary`}>Votre coach</span>
          <h2 className={`font-heading text-4xl sm:text-5xl mt-3 ${isDark ? 'text-white' : 'text-dark'}`}>
            NICOLAS PERROY
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-center max-w-5xl mx-auto">
          {/* Photo(s) */}
          <div className={`transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}>
            {variant === 'about' ? (
              <div className="grid grid-cols-2 gap-3">
                <div className="rounded-xl overflow-hidden shadow-lg col-span-2">
                  <img decoding="async" src={COACH_IMAGES.running} alt="Nicolas Perroy - Compétition CrossFit Saint-Chamond" className="w-full h-64 object-cover object-top" loading="lazy" />
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg">
                  <img decoding="async" src={COACH_IMAGES.squat} alt="Nicolas Perroy - Haltérophilie overhead squat" className="w-full h-48 object-cover" loading="lazy" />
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg">
                  <img decoding="async" src={COACH_IMAGES.barwork} alt="Nicolas Perroy - Muscle-up à la barre" className="w-full h-48 object-cover" loading="lazy" />
                </div>
              </div>
            ) : (
              <div className="relative">
                <div className="rounded-2xl overflow-hidden shadow-2xl">
                  <img decoding="async"
                    src={COACH_IMAGES.squat}
                    alt="Nicolas Perroy - Fondateur et coach CrossFit Saint-Chamond"
                    className="w-full h-80 sm:h-96 object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 bg-primary text-white rounded-xl px-4 py-2 shadow-lg">
                  <span className="font-heading text-sm">FONDATEUR & COACH</span>
                </div>
              </div>
            )}
          </div>

          {/* Bio */}
          <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'}`}>
            <h3 className={`font-heading text-2xl mb-4 ${isDark ? 'text-white' : 'text-dark'}`}>
              COACH SPORTIF &mdash; +15 ANS D'EXPÉRIENCE
            </h3>
            <p className={`text-base leading-relaxed mb-4 ${isDark ? 'text-white/70' : 'text-muted-foreground'}`}>
              Coach sportif depuis plus de 15 ans, Nicolas accompagne tous types de profils avec une approche structurée, progressive et adaptée à chacun. Licence STAPS, Master Préparation Physique & Réathlétisation, BEESAN.
            </p>
            <p className={`text-base leading-relaxed mb-8 ${isDark ? 'text-white/70' : 'text-muted-foreground'}`}>
              Depuis 2015, le CrossFit est devenu une évidence. Une méthode complète et exigeante : développer des capacités durables, en respectant le corps et en construisant des bases solides.
            </p>

            <div className="grid grid-cols-3 gap-4">
              {[
                { icon: Award, label: 'Coach certifié CrossFit' },
                { icon: Heart, label: 'Passionné & dévoué' },
                { icon: Users, label: 'Communauté soudée' },
              ].map(({ icon: Icon, label }, idx) => (
                <div key={idx} className="text-center">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center mx-auto mb-2 ${isDark ? 'bg-primary/20' : 'bg-primary/10'}`}>
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <span className={`text-xs font-medium ${isDark ? 'text-white/60' : 'text-muted-foreground'}`}>{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
